import React from 'react'
import { BetterComponent } from '../../../components/better-component/better-component'
import { BetterSelect } from '../../../components/better-select/better-select'
import { IFilterBuilderProps } from '../interfaces/filter-builder'
import { getClassNames } from '../../../_utils/classnames'
import './style/notification-id.filter-builder.scss'
import { NotificationSearchBar } from '../../../components/notification-search-bar/notification-search-bar'
import { AppService } from '../../../services'
import { Container } from 'typescript-ioc/es5'
import { ReportFilterOperator } from '../enums/report-filter-operator'
import clone from 'clone'

export class NotificationIdFilterBuilder extends BetterComponent<IFilterBuilderProps, any> {
    protected appService: AppService

    constructor(props: IFilterBuilderProps) {
        super(props)

        this.appService = Container.get(AppService)
    }

    public render(): React.ReactNode {
        return (
            <div className={getClassNames('filter', 'nid-filter')}>
                <div className={getClassNames('filter-wrapper')}>
                    <div className={getClassNames('filter-display')}>
                        <span className="filter-op">{this.currentOperatorDisplay}</span>
                    </div>
                    <div className={getClassNames('filter-editor')}>
                        <div className="filter-op">
                            <BetterSelect
                                size="small"
                                disableSearch={true}
                                dropdownClassName="filter-op-dropdown"
                                options={[
                                    { value: ReportFilterOperator.IN, label: 'is' },
                                    { value: ReportFilterOperator.NOT_IN, label: 'is not' },
                                ]}
                                defaultValue={[ReportFilterOperator.IN]}
                                value={this.currentValue.operator}
                                onChange={(operator: string) => {
                                    this.handleChange({ operator })
                                }}
                            />
                        </div>
                    </div>
                    <div className="filter-val">
                        <NotificationSearchBar
                            className="notif-search"
                            mode={this.props.mode === 'display' ? 'display' : 'search'}
                            sources={['MANUAL', 'CAMPAIGN', 'FEED']}
                            value={!this.currentValue.value ? undefined : this.currentValue.value.toString()}
                            placeholder="Search ID or Title"
                            onChange={this.handleNotificationChange}
                            getDropdownContainer={this.appService.getAppContainer}
                        />
                    </div>
                </div>
            </div>
        )
    }

    protected get currentValue(): any {
        const propsValue: any = this.props.value || {}
        return clone({
            field: 'NOTIFICATION_ID',
            operator: propsValue.operator || ReportFilterOperator.IN,
            value: propsValue.value,
        })
    }

    protected get currentOperatorDisplay(): any {
        return this.currentValue.operator === ReportFilterOperator.IN ? 'is' : 'is not'
    }

    protected handleNotificationChange = (notifId: string | undefined) => {
        this.handleChange({ value: !notifId ? undefined : [notifId] })
    }

    protected handleChange(config: any): any {
        if (!!config) {
            this.props.onChange({
                ...this.props.value,
                ...config,
                field: 'NOTIFICATION_ID',
            })
        } else {
            this.props.onChange()
        }
    }
}
